import * as React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { getLocalization } from 'global/global';

interface Props {
  id: string;
  /** Localization key for the field label. */
  label: string;
  value: string;
  onChange: (value: string) => void;
  visible: boolean;
  onToggle: () => void;
}

/** A password input with the show/hide eye the legacy form had. */
export default function PasswordField(props: Props) {
  return (
    <Form.Group className="mb-2">
      <Form.Label>{getLocalization(props.label)}</Form.Label>
      <InputGroup>
        <Form.Control
          id={props.id}
          size="sm"
          type={props.visible ? 'text' : 'password'}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
        <InputGroup.Text onClick={props.onToggle} role="button">
          <i className={`fa fa-lg ${props.visible ? 'fa-eye' : 'fa-eye-slash'}`} />
        </InputGroup.Text>
      </InputGroup>
    </Form.Group>
  );
}
